var map = {
	"./0x1fb9F58AFe55b0c5AEF738c60594A54B38E31Dfc/logo.png": 4082,
	"./0x21C718C22D52d0F3a789b752D4c2fD5908a8A733/logo.png": 67196,
	"./0x792296e2a15e6Ceb5f5039DecaE7A1f25b00B0B0/logo.png": 55518,
	"./0xC584fFD011e16A10fd8329853B9B8DE6E0313AD9/logo.png": 39146,
	"./0xdC19A122e268128B5eE20366299fc7b5b199C8e3/logo.png": 95743,
	"assets/tokenlogo/0x1fb9F58AFe55b0c5AEF738c60594A54B38E31Dfc/logo.png": 4082,
	"assets/tokenlogo/0x21C718C22D52d0F3a789b752D4c2fD5908a8A733/logo.png": 67196,
	"assets/tokenlogo/0x792296e2a15e6Ceb5f5039DecaE7A1f25b00B0B0/logo.png": 55518,
	"assets/tokenlogo/0xC584fFD011e16A10fd8329853B9B8DE6E0313AD9/logo.png": 39146,
	"assets/tokenlogo/0xdC19A122e268128B5eE20366299fc7b5b199C8e3/logo.png": 95743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95237;